import { render, staticRenderFns } from "./AllList.vue?vue&type=template&id=13b9eb4e&scoped=true"
import script from "./AllList.vue?vue&type=script&lang=js"
export * from "./AllList.vue?vue&type=script&lang=js"
import style0 from "./AllList.vue?vue&type=style&index=0&id=13b9eb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9eb4e",
  null
  
)

export default component.exports